import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllNotices } from '../redux/noticeRelated/noticeHandle';
import { Paper, Button } from '@mui/material';
import TableViewTemplate from './TableViewTemplate';

const SeeNotice = () => {
    const dispatch = useDispatch();
    const { currentUser, currentRole } = useSelector(state => state.user);
    const { noticesList, loading, error, response } = useSelector((state) => state.notice);

    useEffect(() => {
        if (currentRole === "Admin") {
            dispatch(getAllNotices(currentUser._id, "Notice"));
        } else {
            dispatch(getAllNotices(currentUser.school._id, "Notice"));
        }
    }, [dispatch]);

    if (error) {
        console.log(error);
    }

    const noticeColumns = [
        { id: 'title', label: 'Title', minWidth: 170 },
        { id: 'details', label: 'Details', minWidth: 100 },
        { id: 'date', label: 'Date', minWidth: 170 },
    ];

    const noticeRows = noticesList.map((notice) => {
        const date = new Date(notice.date);
        const dateString = date.toString() !== "Invalid Date" ? date.toISOString().substring(0, 10) : "Invalid Date";
        return {
            title: notice.title,
            details: notice.details,
            date: dateString,
            id: notice._id,
        };
    });

    return (
        <div style={{ 
            marginTop: '50px', 
            marginRight: '20px', 
            padding: '20px', 
            textAlign: 'center',
            background: 'linear-gradient(135deg, #008080, #FFD700)',
            borderRadius: '15px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
            color: '#fff',
            maxWidth: '95%',
            margin: 'auto'
        }}>
            {loading ? (
                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#FFD700' }}>Loading...</div>
            ) : response ? (
                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#FFD700' }}>No Notices to Show Right Now</div>
            ) : (
                <>
                    <h3 style={{ 
                        fontSize: '30px', 
                        marginBottom: '40px',
                        fontWeight: 'bold',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                    }}>Notices</h3>
                    <Paper sx={{ 
                        width: '100%', 
                        overflow: 'hidden', 
                        padding: '20px',
                        borderRadius: '10px',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)'
                    }}>
                        {Array.isArray(noticesList) && noticesList.length > 0 &&
                            <TableViewTemplate columns={noticeColumns} rows={noticeRows} />
                        }
                    </Paper>
                    <Button 
                        variant="contained"
                        sx={{ 
                            marginTop: '20px', 
                            backgroundColor: '#FFD700', 
                            color: '#008080', 
                            fontWeight: 'bold',
                            '&:hover': { backgroundColor: '#DAA520' },
                            transition: '0.3s ease'
                        }}
                    >
                        Refresh Notices
                    </Button>
                </>
            )}
        </div>
    );
}

export default SeeNotice;
